import { createFileRoute } from '@tanstack/react-router';

/** The author whose works the list shows: a linked account, or a name with no account. */
export interface MarketplaceSearch {
  artist_id?: string;
  artist_name?: string;
}

export const Route = createFileRoute('/marketplace/')({
  validateSearch: (search: Record<string, unknown>): MarketplaceSearch => ({
    artist_id:
      typeof search.artist_id === 'string' && search.artist_id ? search.artist_id : undefined,
    artist_name:
      typeof search.artist_name === 'string' && search.artist_name.trim()
        ? search.artist_name.trim()
        : undefined,
  }),
});
